import { render, staticRenderFns } from "./brainMap.vue?vue&type=template&id=583aa066&scoped=true&"
import script from "./brainMap.vue?vue&type=script&lang=js&"
export * from "./brainMap.vue?vue&type=script&lang=js&"
import style0 from "./brainMap.vue?vue&type=style&index=0&id=583aa066&scoped=true&lang=css&"
import style1 from "./brainMap.vue?vue&type=style&index=1&id=583aa066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583aa066",
  null
  
)

export default component.exports